var map = {
	"./1.jpg": 2951,
	"./2.jpg": 8200,
	"./3.jpg": 1717,
	"./4.jpg": 6718,
	"./5.jpg": 4555,
	"./6.jpg": 1756,
	"./7.jpg": 9801,
	"./mainImg.jpg": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8505;